import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { datadogRum } from "@datadog/browser-rum";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import User from "layouts/User";

import { Credentials } from "./components";
import { urls, mimeType, httpCodes } from "constants/urls";
import { Loading } from "shared/Loading";

const UserCredentials = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [accountsData, setAccountsData] = useState([]);

  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch(urls.accounts, {
      method: "GET",
      headers: {
        Accept: mimeType,
        "Content-Type": mimeType,
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw response;
      })
      .then(({ data }) => {
        setAccountsData(data);
        setLoading(false);
      })
      .catch((response) => {
        datadogRum.addError(response);
        if (response.status === httpCodes.unauthorized) {
          navigate("/sign-out");
        }
      });
  }, [navigate]);

  return (
    <User>
      <Box
        position={"relative"}
        minHeight={"calc(100vh - 300px)"}
        display={"flex"}
        alignItems={"flex-start"}
        justifyContent={"center"}
        height={1}
        sx={{ p: theme.spacing(4) }}
      >
        {loading ? (
          <Loading />
        ) : (
          <Grid container spacing={2}>
            <Grid item container>
              <Typography noWrap={true} variant={"h4"}>
                Credenitals
              </Typography>
            </Grid>
            <Grid item container>
              <Credentials accountsData={accountsData} isMd={isMd} />
            </Grid>
          </Grid>
        )}
      </Box>
    </User>
  );
};

export default UserCredentials;
